import { type FC } from 'react'
import { Layout } from '@egw/layouts'
import { Headers } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { WireReviewPage } from '@egw/features-transfer'

export const ReviewWirePage: FC = () => {
  const { t } = useTranslation()
  return (
    <Layout>
      <Headers title={t('pages.transfer.title')} />
      <WireReviewPage />
    </Layout>
  )
}
